import styled from '@emotion/styled'
import { Button, createTheme } from '@mui/material'
import React from 'react'
import { customStyles } from '../../../styles'

export const MainButton = (props) => {
  
  const { sharp = false } = props
   const CustomMainButton = styled(Button)(({ theme }) => ({
      width: props?.size || 150,
      height: props?.height ? props.height : 35,
      borderRadius: props?.sharp ? 0 : 50,
      boxShadow: theme.shadows[2] || props.shadow,
      fontWeight: 700,
      flexDirection: props?.reverse && 'row-reverse',
      fontSize: props?.fontSize ? props.fontSize : 11,
      padding: 1,
      transition: 'ease 0.2s',
      cursor: 'pointer',
      ...props?.sx,
      '&:active': {
        transform: 'scale(.97)'
      }
   }))
  return (
    <CustomMainButton 
      variant={ props?.variant } 
      disabled={props?.disabled}
      name={props?.name}
      value={props?.value} 
      onClick={ props?.onClick }
      startIcon={props?.icon}
      color={props?.color}
      href={props?.link}
      target="_blank"
    >
        { props?.text }
        { props?.component }
      </CustomMainButton>
  )
}
